<template>
  <v-dialog v-model="showDialog" max-width="450">
    <RescheduleTasksForm
      v-if="showDialog"
      :loading="loading"
      @close="showDialog = false"
      @submit="$emit('submit', $event)"
    />
  </v-dialog>
</template>

<script lang="ts">
import mixins from 'vue-typed-mixins';

import { DialogMixin } from '@/bundles/Dialogs/mixins/DialogMixin';

import RescheduleTasksForm from '@/bundles/Tasks/components/RescheduleTasksForm.vue';

export default mixins(DialogMixin).extend({
  name: 'RescheduleTasksDialog',

  components: { RescheduleTasksForm },

  props: {
    loading: Boolean,
  },
});
</script>
